import React, { Component } from 'react';
import ListAppMobileX0 from "./../../assets/image/List-App-Mobile-X-0.png";
import ListAppMobileX1 from "./../../assets/image/List-App-Mobile-X-1.png";
import ListAppMobileX2 from "./../../assets/image/List-App-Mobile-X-2.png";
import ListAppMobileX3 from "./../../assets/image/List-App-Mobile-X-3.png";
import ListAppMobileX4 from "./../../assets/image/List-App-Mobile-X-4.png";
import ListAppMobileX5 from "./../../assets/image/List-App-Mobile-X-5.png";
import ListAppMobileX6 from "./../../assets/image/List-App-Mobile-X-6.png";
import Image10 from "./../../assets/image/List-App-Mobile-10.png";
import Image12 from "./../../assets/image/List-App-Mobile-12.png";
import MetaTags from 'react-meta-tags'
class SimpleNiceList extends Component {

    componentDidMount(){
     
        var jquery = "/js/custom.js";
        var addScript = document.createElement("script");
        addScript.setAttribute("src", jquery)
        document.body.appendChild(addScript);
    }
   
   render(){ 
   return (
      <div className="simple-nice-list-page"> 
       <MetaTags>
            <title>Simple Nice List App |The Best Shopping List App | Android | iPhone | The Best Coin Flip App</title>
            <meta name="description" content="Nice List App for smart phones" />
            <meta property="og:title" content="The Best List App" />
            <meta property="og:image" content="https://propaganda.world/img/the-best-list-app.jpg" />
            <meta property="og:description" content="The Best List App, Shopping List App, TO-DO list app, Android, IOS" />
        </MetaTags>
        <div id="index-banner" className="parallax-container  parallax-container-auto lg-black">
            <div className="banner-top">
                <div className="container banner-top--content">
                    <div className="row">
                        <div className="col l6 m12">
                            <h1><span className="grey-text">Simple </span> <span className="white-text" >Nice List</span> </h1>
                            <div className="white-text subtitle">
                                <p> Smart Phone App</p>
                            </div>
                            <p className="white-text">Simple, sharp and clean list app</p>
                            <div className="">
                                <a href="https://play.google.com/store/apps/details?id=com.simplenicelist" className="btn btn-store waves-effect waves-light white darken-4">
                                <i className="fab fa-android"></i> 
                                    <h6>Android</h6>
                                    <span>Download</span>
                                </a>
                                <a href="/" className="btn btn-store waves-effect waves-light white darken-4">
                                <i className="fab fa-apple"></i> 
                                    <h6>iOS</h6>
                                    <span>Download</span>
                                </a>
                            </div>

                        </div>
                        <div className="col l6 m12">
            
                        <img src={Image10} className=""  data-aos="fade-up" alt="Unsplashed background img 1" />
                        </div>   
                    </div>
                </div>
            </div>
            <div className="parallax"></div>
        </div>

        <div className="section">
            <div className="container">
                <div className="row center">
                    <h3 className="black-text bolder">Nice List</h3>
                    <h6 className="black-text subtitle ">SmartPhone Application</h6>
                    <img src={Image12} 
                            data-aos="fade-up"
                            data-aos-offset="-100"
                            data-aos-delay="0"
                            data-aos-duration="1000"
                            data-aos-easing="ease-in-out"
                            data-aos-mirror="true"
                            data-aos-once="false"
                            data-aos-anchor-placement="top-center"
                     className="image-center" alt="List Smart Phone Application" />
                </div>
            </div>
        </div>
       <div className="section about">
            <div className="container medium">
                <div className="container-header center">
                    <h2 className=""> Why you need to try Nice List ? </h2>
                    <p className="">Nice List app are created, by request,  to be simple as possible. Inside app you will find just lists and items and nothing more.   </p>
                </div>
                <div className="row">
                    <div className="col m4 text-right top-70 ">
                            <div  
                                data-aos="fade-right"
                                data-aos-offset="10"
                                data-aos-delay="0"
                                data-aos-duration="1000"
                                data-aos-easing="ease-in-out"
                                data-aos-anchor-placement="top-center"
                                className="btn-store waves-effect waves-light white darken-4">
                                <i className="fa fa-wifi right"></i> 
                                <h6>Wi-Fi</h6>
                                <span>You don't need internet connection</span>
                            </div>   
                            <div  
                            
                                data-aos="fade-right"
                                data-aos-offset="10"
                                data-aos-delay="0"
                                data-aos-duration="1000"
                                data-aos-easing="ease-in-out"
                                data-aos-anchor-placement="top-center"
                                className="btn-store waves-effect waves-light white darken-4">
                                <i className="fa fa-unlock-alt right"></i> 
                                <h6>Login</h6>
                                <span>No username, password or reset password</span>
                            </div>  
                            <div  
                            
                                data-aos="fade-right"
                                data-aos-offset="10"
                                data-aos-delay="0"
                                data-aos-duration="1000"
                                data-aos-easing="ease-in-out"
                                data-aos-anchor-placement="top-center"
                                className="btn-store waves-effect waves-light white darken-4">
                                <i className="fa fa-server right"></i> 
                                <h6>Data</h6>
                                <span>App and data stays on your phone</span>
                            </div>     
                            <div  
                                data-aos="fade-right"
                                data-aos-offset="10"
                                data-aos-delay="0"
                                data-aos-duration="1000"
                                data-aos-easing="ease-in-out"
                                data-aos-anchor-placement="top-center"
                                className="btn-store waves-effect waves-light white darken-4">
                                <i className="fa fa-shower right"></i> 
                                <h6>Design</h6>
                                <span>Crisp & clean</span>
                            </div>
                    </div>
                    <div className="col m4 center">
                        <div className="slider center">
                            <ul className="slides">
                                <li>
                                    <img src={ListAppMobileX0} className="margin-center img-height-600" alt="List App iPhone X" />
                                </li>
                                <li>
                                    <img src={ListAppMobileX1} className="margin-center img-height-600" alt="List App iPhone X" />
                                </li>
                                <li>
                                    <img src={ListAppMobileX2} className="margin-center img-height-600" alt="List App iPhone X" />
                                </li>
                                <li>
                                    <img src={ListAppMobileX3} className="margin-center img-height-600" alt="List App iPhone X" />
                                </li>
                                <li>
                                    <img src={ListAppMobileX4} className="margin-center img-height-600" alt="List App iPhone X" />
                                </li>
                                <li>
                                    <img src={ListAppMobileX5} className="margin-center img-height-600" alt="List App iPhone X" />
                                </li>
                                <li>
                                    <img src={ListAppMobileX6} className="margin-center img-height-600" alt="List App iPhone X" />
                                </li>
                            </ul> 
                        </div>       
                    </div>
                    <div className="col m4 gray top-70 ">
                            <div  
                                data-aos="fade-left"
                                data-aos-offset="50"
                                data-aos-delay="0"
                                data-aos-duration="1000"
                                data-aos-easing="ease-in-out"
                                data-aos-anchor-placement="top-center"
                                className="btn-store waves-effect waves-light white darken-4">
                                <i className="fa fa-gear"></i> 
                                <h6>Settings</h6>
                                <span>No Settings, we make it simple</span>
                            </div>   
                            <div  
                                        data-aos="fade-left"
                                        data-aos-offset="10"
                                        data-aos-delay="0"
                                        data-aos-duration="1000"
                                        data-aos-easing="ease-in-out"
                                        data-aos-anchor-placement="top-center"
                                        className="btn-store waves-effect waves-light white darken-4">
                                       <i className="fa fa-id-badge"></i>
                                        <h6>User Frendly?</h6>
                                        <span>Very user-friendly</span>
                                    </div>  
                                     <div  
                                        data-aos="fade-left"
                                        data-aos-offset="10"
                                        data-aos-delay="0"
                                        data-aos-duration="1000"
                                        data-aos-easing="ease-in-out"
                                        data-aos-anchor-placement="top-center"
                                        className="btn-store waves-effect waves-light white darken-4">
                                        <i className="fa fa-money" aria-hidden="true"></i>
                                        <h6>Price</h6>
                                        <span>Nice List is totally free</span>
                                    </div> 
                                    <div  
                                        data-aos="fade-left"
                                        data-aos-offset="10"
                                        data-aos-delay="0"
                                        data-aos-duration="1000"
                                        data-aos-easing="ease-in-out"
                                        data-aos-anchor-placement="top-center"
                                        className="btn-store waves-effect waves-light white darken-4">
                                        <i className="fa fa-microphone"></i> 
                                        <h6>Voice Assistant</h6>
                                        <span>No, we removed that option</span>
                                    </div>    
                              
                             
                    </div>
                </div>
            </div>

           
       </div>

       <div className="section calltoaction lg-black white-text">
            <div className="container">
            <div className="center">
               <h2 className="bolder">Download the Nice List app </h2>
              <p className="subtitle"> from  Google Play  & IOS store</p> 
            </div>
            
                <div className="row">
                   
                    <div className="col s12 margin-center ">
                        <div className="center">
                            <a href="https://play.google.com/store/apps/details?id=com.simplenicelist" className="btn btn-store waves-effect waves-light  darken-4">
                            <i className="fab fa-android"></i> 
                                <h6>Android</h6>
                                <span>Download</span>
                            </a>
                            <a href="/" className="btn btn-store waves-effect waves-light darken-4">
                            <i className="fab fa-apple"></i> 
                                <h6>iOS</h6>
                                <span>Download</span>
                            </a>
                        </div>
           
                    </div>
                  
                </div>
            </div>
       </div>


       <footer className="lg-black darken-1 footer-padding ">
           <div className="white-text center lg-black">
               <a className="grey-text text-darken-1" href="https://propaganda.world"> © 2018 Propaganda World - Website &amp; Application Developers Team</a> 
               <br></br>
               <br></br>
               <span className="grey-text text-darken-1">  </span><a className="grey-text text-darken-1" href="/send-enquiry"> Contact </a> <span className="grey-text text-darken-1"> | </span><a className="grey-text text-darken-1" href="/privacy"> Privacy </a><span className="grey-text text-darken-1"> | </span><a className="grey-text text-darken-1" href="/terms-and-conditions"> Terms </a>
            </div>
        </footer>
    </div>
  )
   }
}

export default SimpleNiceList